export default __webpack_public_path__ + "static/media/dcjs-psblue.682afbde.png";